<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    :before-close="handleClose"
    class="dialog-container"
  >
    <div class="content-box">
      <div v-if="[2, 3].includes(type)">
        <div class="title">退款申请信息</div>
        <p class="info-box">
          订单号：<span>{{ orderInfo.order_no || "-" }}</span>
        </p>
        <p class="info-box">
          订单金额：<span>{{ formatPrice(orderInfo.real_price) }}</span>
        </p>
        <div v-for="item in orderInfo.sub_order_list" :key="item.id">
          <p class="info-box">
            课程名：<span>{{ item.goods_title }}</span>
          </p>
          <p class="info-box">
            ID：<span>{{ item.course_id }}</span>
          </p>
        </div>

        <p class="info-box">
          退款金额：<span>{{ formatPrice(orderInfo.refund_cash) }}</span>
        </p>
        <p class="info-box">
          申请人：<span>{{ orderInfo.nickname }}</span>
        </p>
        <p class="info-box">
          申请人描述信息：<span>{{ orderInfo.apply_desc }}</span>
        </p>
        <p class="info-box">
          申请时间：<span>{{
            parseTime(orderInfo.created_at, "YYYY-MM-DD HH:mm:ss")
          }}</span>
        </p>
        <p class="info-box">附件：</p>
        <p class="info-box file-box">
          <el-button
            v-for="(item, index) in dealAttch(orderInfo.apply_attachments)"
            :key="index"
            type="text"
            @click="downloadFile(item.url)"
          >
            {{ item.name }}
          </el-button>
        </p>
      </div>
      <div v-else>
        <div class="title">订单信息</div>
        <p class="info-box">
          订单号：<span>{{ orderInfo.order_no }}</span>
        </p>
        <p class="info-box">
          订单金额：<span>{{ formatPrice(orderInfo.real_price) }}</span>
        </p>
        <div v-for="item in orderInfo.sub_order_list" :key="item.id">
          <p class="info-box">
            课程名：<span>{{ item.goods_title }}</span>
          </p>
          <p class="info-box">
            ID：<span>{{ item.course_id }}</span>
          </p>
        </div>
        <!-- <p class="info-box">
          课程名：<span>{{ orderInfo.goods_title }}</span>
        </p>
        <p class="info-box">
          课程ID：<span>{{ orderInfo.course_id }}</span>
        </p> -->
      </div>
      <div v-if="[1, 2].includes(type)">
        <el-form
          :model="inputInfo"
          :rules="rules"
          ref="infoForm"
          label-position="top"
        >
          <el-form-item label="申请描述（对方可见）" prop="desc" required>
            <el-input
              v-model="inputInfo.desc"
              type="textarea"
              rows="4"
              show-word-limit
              maxlength="300"
              :placeholder="'请输入描述信息。\n 提示：良好的沟通是事半功倍的最佳助力。'"
            />
          </el-form-item>
          <el-form-item label="上传附件（对方可见）" prop="attachmentList">
            <UploadImage
              v-model="inputInfo.attachmentList"
              :sts-api="'/v1/cos/refundSts'"
              :sts-params="uploadParams"
              :limit="3"
              tips="只允许图片（JPG\PNG）最多三张，单个文件不得超过10MB"
              :data-type="'object'"
            />
          </el-form-item>
        </el-form>
        <!-- <div class="title required">反馈信息（对方可见）</div>

        <div class="title required">上传附件（对方可见）</div> -->
      </div>
      <div v-else>
        <div class="title required">退款处理结果</div>
        <p class="info-box">
          处理结果：<span>{{ refundStatus[orderInfo.reply_result] }}</span>
        </p>
        <p class="info-box">
          机构名：<span>{{ orderInfo.org_name || "-" }}</span>
        </p>
        <template v-if="orderInfo.reply_result !== 1">
          <p class="info-box">
            处理时间：<span>{{
              parseTime(orderInfo.updated_at, "YYYY-MM-DD HH:mm:ss")
            }}</span>
          </p>
          <p class="info-box">
            反馈信息：<span>{{ orderInfo.reply_desc }}</span>
          </p>
          <p class="info-box">附件：<span /></p>
          <p class="info-box file-box">
            <el-button
              v-for="(item, index) in dealAttch(orderInfo.reply_attachments)"
              :key="index"
              type="text"
              @click="downloadFile(item.url)"
            >
              {{ item.name }}
            </el-button>
            <!-- <img
            v-for="(item, index) in dealAttch(orderInfo.reply_attachments)"
            :key="index"
            :src="item"
            alt=""
          /> -->
          </p>
        </template>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="type === 1"
        size="small"
        type="primary"
        @click="submitApply"
        >提交退款申请</el-button
      >
      <el-button
        v-if="type === 2"
        size="small"
        type="primary"
        @click="agreeRefund"
        >同意退款</el-button
      >
      <el-button
        v-if="type === 2"
        size="small"
        type="danger"
        @click="refuseRefund"
        >拒绝退款</el-button
      >
      <el-button
        :type="type !== 2 && type !== 1 ? 'primary' : 'default'"
        size="small"
        @click="handleClose"
        >关 闭</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import formatTime from "@saas/components/src/utils/filters.js";
import {
  applyRefund,
  getUploadSts,
} from "@saas/server-api/src/learning-center";
import { REFUND_STATUS } from "@saas/components/src/constants";
import { UploadImage } from "@saas/components/src";

export default {
  components: { UploadImage },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: [String, Number],
      default: 1, // 1 申请退款 2 处理退款 3 退款详情
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      orderInfo: {},
      inputInfo: {
        desc: "",
        attachmentList: [],
      },
      parseTime: formatTime.formatSelfTime,
      refundStatus: REFUND_STATUS,
      rules: {
        desc: [{ required: true, message: "请输入申请描述" }],
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
    title() {
      if (+this.type === 1) {
        return "申请退款";
      } else if (+this.type === 2) {
        return "处理退款";
      } else if (+this.type === 3) {
        return "退款处理详情";
      } else {
        return "退款";
      }
    },
    uploadParams() {
      return {
        org_id: this.orderInfo.org_id,
        order_no: this.orderInfo.order_no,
      };
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        try {
          this.orderInfo = JSON.parse(JSON.stringify(this.data));
          console.log(this.orderInfo);

          this.inputInfo = {
            desc: "",
            attachmentList: [],
          };
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.$refs.infoForm) {
                this.$refs.infoForm.clearValidate();
              }
            }, 500);
          });
        } catch (e) {
          this.orderInfo = {};
          this.inputInfo = {
            desc: "",
            attachmentList: [],
          };
        }
      }
    },
  },

  methods: {
    downloadFile(url) {
      window.open(url);
    },
    dealAttch(val) {
      if (typeof val === "string") {
        return JSON.parse(val || "[]");
      } else {
        return [];
      }
    },
    formatPrice(val) {
      if (val) {
        return "￥" + (val / 100).toFixed(2);
      } else {
        return "-";
      }
    },
    // 保留一位小数，向下取整
    formatNumber(num) {
      return Math.floor(num * 10) / 10;
    },
    formatTime(milliseconds) {
      const totalSeconds = Math.floor(milliseconds / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return `${hours.toString().padStart(2, "0")}时${minutes
        .toString()
        .padStart(2, "0")}分${seconds.toString().padStart(2, "0")}秒`;
    },
    indexMethod(index) {
      return index + 1;
    },
    getData() {},

    handleClose() {
      this.$emit("close");
    },
    // 申请退款
    submitApply() {
      this.$refs["infoForm"].validate((valid) => {
        if (valid) {
          this.$confirm(
            "<div>确认要申请退款吗？</div><div>申请后，请耐心等待商家的操作结果</div>",
            "二次确认",
            {
              confirmButtonText: "确认操作",
              cancelButtonText: "取消",
              dangerouslyUseHTMLString: true,
            }
          )
            .then(() => {
              this.applyRefund();
            })
            .catch(() => {});
        }
      });
    },
    // 同意退款
    agreeRefund() {
      this.$confirm(
        "<div>确认要同意退款吗？</div><div>确认同意退款后，会按照退款申请额按照用户原有支付渠道退回，本退款单将关闭。</div><div>涉及您的资金变动，务必谨慎确认后操作。</div>",
        "二次确认",
        {
          confirmButtonText: "确认操作",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          //   this.dealRefund(1);
        })
        .catch(() => {});
    },
    // 拒绝退款
    refuseRefund() {
      this.$confirm(
        "<div>确认要拒绝退款吗？</div><div>拒绝退款后，本退款单将关闭，请确认这是与买方完成妥善沟通后的操作，避免买方重复提交退款。</div>",
        "二次确认",
        {
          confirmButtonText: "确认操作",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          //   this.dealRefund(2);
        })
        .catch(() => {});
    },
    applyRefund() {
      applyRefund({
        attach: JSON.stringify(this.inputInfo.attachmentList),
        desc: this.inputInfo.desc,
        // order_no: this.orderInfo.order_no,
        pay_order_id: this.orderInfo.id,
      })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("处理成功");
            this.$emit("close");
            this.$emit("refresh");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.error("处理退款失败>>>", err);
        });
    },
    dealRefund(result) {
      console.log(result);
      //   dealRefundHandle({
      //     attach: 1,
      //     desc: 1,
      //     order_no: 1,
      //     reply_result: result,
      //   })
      //     .then((res) => {
      //       if (res.code === 1) {
      //         this.$message.success("处理成功");
      //         this.$emit("close");
      //       } else {
      //         this.$message.error(res.message);
      //       }
      //     })
      //     .catch((err) => {
      //       console.error("处理退款失败>>>", err);
      //     });
    },
    getStsData(file) {
      return getUploadSts({
        org_id: this.user.org_id,
        order_no: this.orderInfo.order_no,
        filename: file.name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-container {
  ::v-deep {
    .el-dialog__body {
      padding: 10px 20px 10px 40px;
    }
  }
}

.content-box {
  height: 600px;
  overflow: auto;
}

.title {
  font-size: 16px;
  line-height: 36px;
  color: #333;
  font-weight: 700;
}

.info-box {
  line-height: 28px;
}
.file-box {
  display: flex;
  flex-direction: column;

  .el-button {
    margin-left: 0;
    text-align: left;
  }
}

.export-btn {
  float: right;
  width: 80px;
  height: 34px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  color: $blue-color;
}
</style>
